import {combineReducers} from 'redux';
import * as ACTION from './constants';

let bags = (state = [], action) => {
    let {type, payload} = action;

    switch (type) {
        case ACTION.FETCH_SAME_DAY_BAGS.SUCCESS:
            return payload.bags;

        case ACTION.CLEAR_STATE:
            return [];

        default:
            return state;
    }
};

let loading = (state = false, action) => {
    switch (action.type) {
        case ACTION.FETCH_SAME_DAY_BAGS.REQUEST:
            return true;

        case ACTION.FETCH_SAME_DAY_BAGS.SUCCESS:
        case ACTION.FETCH_SAME_DAY_BAGS.FAILED:
            return false;

        default:
            return state;
    }
};

export default combineReducers({
    bags,
    loading,
});
